import type { CompanyInfoTabProps } from '../../types'
import { useCompanyInfoTab } from '../../hooks/useCompanyInfoTab'
import { CompanyInfoCompanySection } from './companyInfo/CompanyInfoCompanySection'
import { CompanyInfoPhysicalAddressSection } from './companyInfo/CompanyInfoPhysicalAddressSection'
import { CompanyInfoFederalIdSection } from './companyInfo/CompanyInfoFederalIdSection'
import { CompanyInfoMailingAddressSection } from './companyInfo/CompanyInfoMailingAddressSection'
import { CompanyInfoMapSection } from './companyInfo/CompanyInfoMapSection'
import { CompanyInfoManagementSection } from './companyInfo/CompanyInfoManagementSection'
import { CompanyInfoDialogs } from './companyInfo/CompanyInfoDialogs'
import tabStyles from '../../styles/companyInfoTab.module.css'

export function CompanyInfoTab(props: CompanyInfoTabProps) {
    const vm = useCompanyInfoTab(props)

    return (
        <form
            data-testid="company-info-tab-form"
            onSubmit={vm.handleSubmit(vm.onSubmit)}
            className={`${tabStyles.tabContent} animate-in fade-in duration-300`}
            data-tab-id="companyinfo"
        >
            <CompanyInfoCompanySection {...vm} />
            <CompanyInfoPhysicalAddressSection {...vm} />
            <CompanyInfoMailingAddressSection {...vm} />
            <CompanyInfoFederalIdSection {...vm} />
            {vm.showMap && <CompanyInfoMapSection {...vm} />}
            <CompanyInfoManagementSection {...vm} />
            <button
                type="submit"
                data-testid="company-info-hidden-submit"
                tabIndex={-1}
                aria-hidden
                className="pointer-events-none absolute h-0 w-0 opacity-0"
            />
            <CompanyInfoDialogs {...vm} />
        </form>
    )
}
